import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=3c433597&"
import script from "./Contact.ts?vue&type=script&lang=js&"
export * from "./Contact.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports